import { PhoneNumberConfig, usePhoneNumber } from '@afterpaytouch/core'
import { useRouter } from 'next/router'
import { mapLocales } from '../../utils/mapLocales'
import { SupportedLocale } from '@afterpay/types'

export const useFormatMobile = (mobile: string): string => {
  const country = mapLocales('locale', useRouter()?.locale as SupportedLocale)
  const { formatNational } = usePhoneNumber({ country } as PhoneNumberConfig)
  return formatNational(mobile) ?? mobile
}
